import React from 'react';
import {
  Sec,
  SecTitle,
  Box,
  Mini,
  MiniItem,
  ReportTable,
  Note,
} from '../styled';
import LoadingML from '@/components/LoadingML';
import { fmtThousand } from '@/utils/comUtil';

// 购票漏斗：按 demo-开发用.html 视觉
//   标题 + mini（详情页 UV / 成交人数）+ 表格（环节/人数/上一步转化/占详情页/可视化）
// 数据：state.performSales.funnel
const PurchaseFunnel = ({ data, loading }) => {
  const { detailUv = 0, tsjBuyers = 0, funnel = [] } = data || {};
  const top = funnel[0]?.n || 0;

  return (
    <Sec>
      <SecTitle>购票漏斗</SecTitle>
      <Box>
        <LoadingML loading={loading ? 1 : 0}>
          <Mini>
            <MiniItem>
              <div className="l">详情页 UV</div>
              <div className="v">{fmtThousand(detailUv, 0)}</div>
            </MiniItem>
            <MiniItem>
              <div className="l">成交人数</div>
              <div className="v">{fmtThousand(tsjBuyers, 0)}</div>
            </MiniItem>
          </Mini>

          <ReportTable>
            <thead>
              <tr>
                <th style={{ width: '16%' }}>环节</th>
                <th style={{ width: '14%' }}>人数</th>
                <th style={{ width: '14%' }}>上一步转化</th>
                <th style={{ width: '14%' }}>占详情页</th>
                <th className="bar-cell">可视化</th>
              </tr>
            </thead>
            <tbody>
              {funnel.map((f) => {
                const share = top ? ((f.n / top) * 100).toFixed(1) : '—';
                const shareTxt = share === '—' ? '—' : `${share}%`;
                const prev = f.prev;
                const width =
                  share === '—' ? '0%' : `${share > 100 ? 100 : share}%`;
                const barCls = f.gold ? ' light' : '';
                return (
                  <tr key={f.name}>
                    <td>{f.name}</td>
                    <td>{fmtThousand(f.n, 0)}</td>
                    <td>{prev}</td>
                    <td>{shareTxt}</td>
                    <td className="bar-cell">
                      <div className="bar-bg">
                        <div className={`bar${barCls}`} style={{ width }} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </ReportTable>

          <Note>
            各环节为本周期内到达该页面的<b>去重人数</b>
            ；漏斗依赖小程序埋点，若某环节无埋点则该行留空、不做估算。
            <b>仅台上见小程序口径</b>
            ——猫眼、大麦的用户不经过台上见详情页，因此成交人数小于总览销量对应的人数。
          </Note>
        </LoadingML>
      </Box>
    </Sec>
  );
};

export default PurchaseFunnel;
